import type { Multiply } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const multiplyResolver = createSimpleNamedExpressionResolver<Multiply>(
  'multiply',
  values => values.reduce((p, c) => p * Number(c), 1)
);
